import HTTP from "@/_helpers/http";
import { PROFILE__API } from "@/_helpers/urls";
import { PROFILE__MUTATIONS } from "../mutation-types";
import { PROFILE__ACTIONS } from "../action-types";
import toast from "@/services/Notification";

const state = {
  account_summary: null,
};

const getters = {};

const mutations = {
  [PROFILE__MUTATIONS.ACCOUNTSUMMARY](state, data) {
    state.account_summary = data;
  },
  [PROFILE__MUTATIONS.PROFITLOSS](state, data) {
    state.profit_loss = data;
  },
};

const actions = {
  async [PROFILE__ACTIONS.ACCOUNTSUMMARY]({ commit }) {
    try {
      const response = await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).get(PROFILE__API.ACCOUNTSUMMARY);
      commit(PROFILE__MUTATIONS.ACCOUNTSUMMARY, response.data);
    } catch (error) {
      console.log(error);
    }
  },
   async [PROFILE__ACTIONS.PROFITLOSS]({ commit }) {
    try {
      const response = await HTTP({trackProgress: true, loadingText: 'Processing...'}).get(PROFILE__API.PROFITLOSS);
      commit(PROFILE__MUTATIONS.PROFITLOSS, response.data);
    } catch (error) {
      console.log(error);
    }
  },
};

export default {
  namespaced: true,
  strict: true,
  state,
  getters,
  actions,
  mutations,
};
